import styled from 'styled-components';
import { colors } from '@prisjakt/ui-base';

export const FacetItem = styled.span`
  padding: 0px 10px;
  > svg {
    transform: translate(3px, 3px);
    > path {
      fill: ${colors.lightBlue1};
    }
  }
`;
